import React from 'react';
import { useFilesConfig } from '../data/filesconfig-hooks';

function File(props) {
    const { filesConfig, deleteDetail, restoreDetail, getDetail, setDetailDialogID, moveFileUp, moveFileDown } = useFilesConfig();

    const accountFileID = props.Id;
    const detail = getDetail(accountFileID);

    const OnDeleteClick = (ev) => {
        ev.preventDefault();
        if (isActive) {
            deleteDetail(accountFileID);
        } else {
            restoreDetail(accountFileID);
        }
    };

    const OnCostClick = (ev) => {
        ev.preventDefault();
        toggleDialog();
    };
    const onMoveUpClick = (ev) => {
        ev.preventDefault();
        moveFileUp(accountFileID);
    };
    const onMoveDownClick = (ev) => {
        ev.preventDefault();
        moveFileDown(accountFileID);
    };

    const toggleDialog = () => {
        setDetailDialogID(accountFileID);
    };

    const imagePreview = filesConfig.ShowThumbnail ? <td className="grid-col-max-120"><img src={detail.ThumbnailUrl} style={{ maxWidth: 100 }}/></td> : null;
    const dimensions = filesConfig.ShowDimensions ? <td>{detail.Dimensions}</td> : null;
    const isActive = detail.IsActive;
    const deleteLabel = isActive ? "[![Delete]!]" : "[![Restore]!]";
    const deleteButtonClass = isActive ? "button k-button button-secondary" : "button k-button k-button-transparent";

    return (
        <tr className="datagriditem">
            <td>
                <a onClick={onMoveDownClick} title='[![Move file up]!]'>
                    <i className='fa fa-chevron-up'></i>
                </a>&nbsp;
                <a onClick={onMoveUpClick} title='[![Move file down]!]'>
                    <i className='fa fa-chevron-down'></i>
                </a>
            </td>
            {imagePreview}
            <td>
                {detail.Name}
            </td>
            <td>
                {detail.Caption}
            </td>
            <td>
                {detail.FileTypeDisplay}
            </td>
            {dimensions}
            <td>
                {detail.FileSize}
            </td>
            <td>
                {detail.CreatedBy}
            </td>
            <td>
                {detail.CreatedDate}
            </td>
            <td className="align-center"><i className={detail.IsActive ? "fa fa-check" : ""}></i></td>
            <td className="grid-col-max-120">
                <button className="button button-secondary k-button" type="button" onClick={OnCostClick}>
                    <span>[![Edit]!]</span>
                </button>
                <button className={deleteButtonClass} type="button" onClick={OnDeleteClick}>
                    <span>{deleteLabel}</span>
                </button>
            </td>
        </tr>
    );
}

export default File;